import React, { useEffect, useState } from 'react';

export const PRINTLOGIC_CREATION_STATUSES = [
  'Waiting For Artwork',
  'Design',
  'On Proof',
  'On Hold',
  'In Progress'
];

const PrintlogicOrderStatusModal = ({ isOpen, onCancel, onConfirm, isSubmitting = false }) => {
  const [selectedStatus, setSelectedStatus] = useState('In Progress');

  useEffect(() => {
    if (isOpen) {
      setSelectedStatus('In Progress');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm(selectedStatus);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Set PrintLogic Status</h2>
        <p className="text-sm text-gray-600 mb-4">
          Choose the initial status for this order in PrintLogic.
        </p>

        <div className="space-y-2 mb-6">
          {PRINTLOGIC_CREATION_STATUSES.map((status) => (
            <label key={status} className="flex items-center gap-3 rounded border border-gray-200 px-3 py-2 cursor-pointer hover:bg-gray-50">
              <input
                type="radio"
                name="printlogic-order-status"
                value={status}
                checked={selectedStatus === status}
                onChange={(event) => setSelectedStatus(event.target.value)}
                className="text-blue-600"
              />
              <span className="text-sm text-gray-900">{status}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {isSubmitting ? 'Submitting...' : 'Submit Order'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PrintlogicOrderStatusModal;
